<template>
  <span class="ui-center-ellipsis">
    <span class="front">
      <slot />
    </span>
  </span>
</template>

<script>
export default {
  name: 'UiCenterEllipsis',
  components: {
  },
  props: {
  },
  data () {
    return {
      needToSplit: false
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {
    this.check()
  },
  methods: {
    check () {
      const $el = this.$el
      const $front = this.$el.querySelector('.front')
      if ($front.offsetWidth > $el.offsetWidth) {
        $el.title = $front.textContent
        $el.classList.add('splited')

        let $back = this._$back
        if (!$back) {
          $back = document.createElement('span')
          $el.appendChild($back)
        }
        $back.className = 'back'
        $back.innerHTML = ''

        const text = $front.textContent
        const backWidth = $el.offsetWidth - $front.offsetWidth
        for (let i = text.length - 1; i > -1; i--) {
          $back.innerHTML = text[i] + $back.innerHTML
          if ($back.offsetWidth > backWidth) {
            $back.innerHTML = text.substring(i + 1)
            break
          }
        }

        $back.className = 'back placed'
        this._$back = $back
      } else {
        $el.title = ''
        $el.classList.remove('splited')
        if (this._$back) {
          $el.removeChild(this._$back)
          delete this._$back
        }
      }
    }
  }
}
</script>

<style lang="scss">
.ui-center-ellipsis {
  white-space: nowrap;
  display: block;
  overflow: hidden;

  .front,
  .back {
    display: inline-block;
    overflow: hidden;
  }

  &.splited {
    display: flex;

    .front {
      width: calc(50% + 1em);
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .back {
      text-align: right;
      &.placed {
        flex: 1;
      }
    }
  }
}
</style>
